import { useRecoilValue } from "recoil";
import classNames from "classnames";
import { useTheme } from "@/comn/hooks";
import { Icon } from "@/comn/components";
import { mediaState } from "@/comn/features/recoil";

export const HeaderThemeToggle = () => {
    const { lg } = useRecoilValue(mediaState);
    const {
        theme: { isDark },
        setTheme,
    } = useTheme();

    return (
        <div className="flex relative bg-header rounded h-[40px] items-center gap-[4px] px-[4px]">
            <div
                className={classNames(
                    "absolute top-[4px] left-[4px] h-[32px] rounded bg-primary z-[1] transition-transform will-change-transform",
                    isDark === "true" && "translate-x-[calc(100%+4px)]",
                    lg ? "w-[72px]" : "w-[40px]",
                )}
            />
            <button
                className={classNames(
                    "flex h-full items-center justify-between z-[2] px-[12px]",
                    lg ? "w-[72px]" : "w-[40px]",
                )}
                onClick={() => setTheme((prev) => ({ ...prev, isDark: "false" }))}
            >
                <Icon icon="light" size="sm" className="fill-primary-contrast dark:fill-white" />
                {lg && <span className="text-primary-contrast dark:text-white">Light</span>}
            </button>
            <button
                className={classNames(
                    "flex h-full items-center justify-between z-[2] px-[12px]",
                    lg ? "w-[72px]" : "w-[40px]",
                )}
                onClick={() => setTheme((prev) => ({ ...prev, isDark: "true" }))}
            >
                <Icon icon="dark" size="sm" className="fill-black dark:fill-primary-contrast" />
                {lg && <span className="text-black dark:text-primary-contrast">Dark</span>}
            </button>
        </div>
    );
};
